import { Box, Button, useMediaQuery } from "@mui/material";
import React from "react";
import congratslogo from "../assets/Logo-investek.png";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";

const Congrats = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const SignInLink = process.env.REACT_APP_SIGNIN_URL;
  const navigate = useNavigate();
  const handleSignin = () => {
    if (SignInLink) {
      window.open(SignInLink, "_blank");
    } else {
      console.error("SIGNIN_URL is not defined in environment variables");
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <>
      {isSmallScreen ? (
        <span>
          {" "}
          <Box sx={styles.formboxresponsive}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <img src={congratslogo} alt="logo" />
            <Typography
              sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "4px" }}
            >
              Congratulation!
            </Typography>
            <div>
              {" "}
              Your account registration is completed. You can login to your
              Amigo account.
            </div>
            <div style={{ marginTop: "8px", color: "gray" }}>
              Have a question?
            </div>
            <div style={{ color: "gray" }}>
              Email:<b> partnership@InvesTek.in</b>
            </div>
            <Button onClick={handleSignin} sx={styles.btn}>
              Sign In
            </Button>
          </Box>
        </span>
      ) : (
        <span>
          {" "}
          <Box sx={styles.formbox}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <img src={congratslogo} alt="logo" />
            <Typography
              sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "4px" }}
            >
              Congratulation!
            </Typography>
            <div>
              Your account registration is completed. You can login to your
              Amigo account.
            </div>
            <div style={{ marginTop: "8px", color: "gray" }}>
              Have a question?
            </div>
            <div style={{ color: "gray" }}>
              Email:<b> partnership@InvesTek.in</b>
            </div>
            <Button onClick={handleSignin} sx={styles.btn}>
              Sign In
            </Button>
          </Box>
        </span>
      )}
    </>
  );
};

export default Congrats;

const styles = {
  formbox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "420px",
    width: "420px",
  },
  formboxresponsive: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "420px",
    width: "320px",
  },
  btn: {
    marginTop: "2em",
    width: "120px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
